import * as React from 'react';
export const thumbsUpSvg = React.forwardRef(function thumbsUpSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M8.152 0a2.62 2.62 0 0 1 2.612 2.838l-.255 3.054a.1.1 0 0 0 .1.108H13.5C14.88 6 16 7.143 16 8.523c0 .31-.072.622-.211.9L15.25 10.5v1.145a1 1 0 0 1-.224.63l-.588.725-.28.895A3 3 0 0 1 11.294 16H2a2 2 0 0 1-2-2V9a2 2 0 0 1 2-2h2l.001-.002 2.545-5.94A1.747 1.747 0 0 1 8.152 0ZM5.5 7.308V14.5h5.794a1.5 1.5 0 0 0 1.432-1.053l.28-.894a1.5 1.5 0 0 1 .267-.499l.477-.587V10.5a1.5 1.5 0 0 1 .158-.67l.54-1.079a.519.519 0 0 0 .052-.228 1.02 1.02 0 0 0-1-1.023h-2.891a1.6 1.6 0 0 1-1.595-1.733l.255-3.053A1.12 1.12 0 0 0 8.152 1.5a.247.247 0 0 0-.227.15L5.5 7.308ZM4 8.5H2a.5.5 0 0 0-.5.5v5a.5.5 0 0 0 .5.5h2v-6Z',
    }),
  );
});
thumbsUpSvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var thumbsUp = {
  category: 'icon',
  colorable: true,
  name: 'thumbsUp',
  svg: thumbsUpSvg,
};
